import axios from 'axios'



const client = axios.create({ baseURL: process.env.REACT_APP_BASE_URL })

client.interceptors.request.use(function (config) {
    // Do something before request is sent
   
    config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem("token"))}`
   
    return config;
}, function (error) {
    
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
client.interceptors.response.use(function (response) {
    
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
   

    const  errorConfig = error.config;

    if (error?.response?.status === 401 && errorConfig.url !== 'auth/login') {
       
        window.location.replace("/login")
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});

export default client;